import React from "react";
import "./LogoGrid.less";

interface LogoGridProps {
    description?: string;
    logos?: Logo[];
}

interface Logo {
    title: string;
    url: string;
}

const LogoGrid: React.FC<LogoGridProps> = ({ description, logos }) => (
    <div className="logo-grid">
        {description && <p dangerouslySetInnerHTML={{ __html: description }} />}
        <div className="logo-grid__grid-container">
            {logos?.map((logo, index) => (
                <div key={index} className="logo-grid__logo-container">
                    <img className="logo-grid__logo" src={logo.url} alt={logo.title} />
                </div>
            ))}
        </div>
    </div>
);

export default LogoGrid;
